export var SolutionInclude = {
    images: true,
    actionAreas: true,
    coBenefits: true,
    subcategory: true,
    scope: true,
    territory: true,
    industries: true,
    supplier: {
        include: {
            logo: true,
        },
    },
    category: true
};
//# sourceMappingURL=Solution.js.map